import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/utils';
import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';

const ChatEmpty = () => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <div className="flex flex-col items-center justify-center text-center h-full p-8 gap-6">
      <MessageCircle
        className={cn(
          'w-12 h-12 text-muted-foreground opacity-90',
          'animate-pulse',
        )}
      />
      <h6 className="font-medium text-lg text-foreground">
        {t('chat.empty.title')}
      </h6>
      <p className="text-muted-foreground max-w-md">
        {t('chat.empty.description')}
      </p>
      <Button variant="outline" onClick={handleOpenDialog}>
        {t('chat.empty.learnMore')}
      </Button>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{t('chat.empty.dialog.title')}</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="text-sm text-muted-foreground mb-4">
              {t('chat.empty.dialog.description')}
            </p>
            <ul className="space-y-2 list-disc list-inside text-muted-foreground">
              <li className="text-sm">{t('chat.empty.features.answers')}</li>
              <li className="text-sm">{t('chat.empty.features.summaries')}</li>
              <li className="text-sm">{t('chat.empty.features.search')}</li>
              <li className="text-sm">{t('chat.empty.features.navigation')}</li>
            </ul>
          </div>
          <DialogFooter>
            <Button onClick={handleCloseDialog}>
              {t('chat.empty.dialog.button')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ChatEmpty;
